import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import './FilterBar.css';

export enum Operator {
  Equals = 'equals',
  NotEquals = 'not equals',
  Contains = 'contains',
  DoesNotContain = 'not contains',
  StartsWith = 'starts with',
  EndsWith = "ends with",
  GreaterThan = 'greater than',
  LessThan = 'less than',
  GreaterThanOrEqual = "greater than or equal",
  LessThanOrEqual = "less than or equal"
}

export interface Filter {
  field: string;
  oper8tor: Operator;
  value: string;
}

interface FilterBarProps {
  onFilterChange: (filters: Filter[]) => void;
  columns: any[];
}

const FilterBar: React.FC<FilterBarProps> = ({ onFilterChange, columns }) => {
  const [selectedFilters, setSelectedFilters] = useState<Filter[]>([]);
  const [newFilter, setNewFilter] = useState<Filter>({ field: '', oper8tor: Operator.Equals, value: '' });
  const [validationErrors, setValidationErrors] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    onFilterChange(selectedFilters);
  }, [selectedFilters]);

  const handleAddFilter = () => {
    const errors: { [key: string]: string } = {};
    if (!newFilter.field) {
      errors.field = 'Field is required';
    }
    if (!newFilter.value.trim()) {
      errors.value = 'Value is required';
    }
    setValidationErrors(errors);
    if (Object.keys(errors).length > 0) {
      return;
    }
    setSelectedFilters([...selectedFilters, newFilter]);
    setNewFilter({ field: '', oper8tor: Operator.Equals, value: '' });
    setValidationErrors({});
  };

  const removeFilter = (index: number) => {
    setSelectedFilters(selectedFilters.filter((_, i) => i !== index));
  };

  const handleInputChange = (key: string, value: string) => {
    setNewFilter({ ...newFilter, [key]: value });
    setValidationErrors({ ...validationErrors, [key]: '' });
  };

  return (
    <div className="filterBar">
      <>
        <Row>
          <Col lg={5}>
            {selectedFilters.length > 0 ? null : <span className='ms-2'><i className="fas fa-info-circle bleu me-2" />Select criteria and click <i>Apply</i> to add filters</span>}
            {selectedFilters.map((filter, index) => (
              <div key={index} className="filterSummary" onClick={() => removeFilter(index)}>
                <span >{filter.field}          <b>{filter.oper8tor}</b>             {filter.value}</span>
                <span ></span>
                <span></span>
                <i className="fas fa-trash delIcon"></i>
              </div>
            ))}
          </Col>
          <Col lg={4}>
            <table className="addFilterInputs">
              <tbody>
                <tr>
                  <td className="addFilterInputs">
                    <div className="custom-select">
                      <Form.Control as="select" value={newFilter.field} onChange={(e) => handleInputChange('field', e.target.value)} className="filterInput" size="sm">
                        <option value="">Select Field</option>
                        {columns.filter(c => c.filterBy !== undefined).map((column, index) => (
                          <option key={index} value={column.filterBy}>{column.Header}</option>
                        ))}
                      </Form.Control>
                    </div>
                    {validationErrors.field && <span style={{ color: 'red' }}>{validationErrors.field}</span>}
                  </td>
                  <td className="addFilterInputs" style={{ maxWidth: "100px" }} >
                    <div className="custom-select">
                      <Form.Control as="select" value={newFilter.oper8tor} onChange={(e) => handleInputChange('oper8tor', e.target.value as Operator)} className="filterInput" size="sm" >
                        {Object.values(Operator).map((op) => (
                          <option key={op} value={op}>{op}</option>
                        ))}
                      </Form.Control>
                    </div>
                  </td>
                  <td className="addFilterInputs" style={{ maxWidth: "100px" }} >
                    <Form.Control type="text" placeholder="Value" value={newFilter.value} onChange={(e) => handleInputChange('value', e.target.value)} className="filterInput" size="sm" />
                    {validationErrors.value && <span style={{ color: 'red' }}>{validationErrors.value}</span>}
                  </td>
                  <td className="addFilterInputs">
                    <Button variant="primary applyBtn" onClick={handleAddFilter} size="sm">
                      <i className="rbPrimaryIcon-custom" style={{ backgroundImage: `url("images/16/funnel_add.png")`, "marginRight": "5px" }} ></i>
                      Apply Filter
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>


          </Col>

        </Row>
      </>
    </div>
  );
};

export default FilterBar;
